import { DateRange, presetRange, rangeLabel } from '../../lib/dateRange'

/**
 * The date range control every report shares. The rules it works from live in
 * src/lib/dateRange.ts, because the services that do the filtering need exactly
 * the same definition of "inside the period" as the screen that sets it.
 */

const PRESETS: { key: string; label: string }[] = [
  { key: 'this_month', label: 'This month' },
  { key: 'last_month', label: 'Last month' },
  { key: 'this_quarter', label: 'This quarter' },
  { key: 'this_fy', label: 'This FY' },
  { key: 'last_fy', label: 'Last FY' },
  { key: 'all', label: 'All Time' },
]

export default function ReportRangeFilter({
  value,
  onChange,
  label = 'Period',
}: {
  value: DateRange
  onChange: (r: DateRange) => void
  label?: string
}) {
  return (
    <div className="rep-toolbar">
      <label className="rep-month-label">{label}</label>
      <input
        className="rep-select"
        type="date"
        value={value.from}
        max={value.to || undefined}
        onChange={(e) => onChange({ ...value, from: e.target.value })}
      />
      <label className="rep-month-label">to</label>
      <input
        className="rep-select"
        type="date"
        value={value.to}
        min={value.from || undefined}
        onChange={(e) => onChange({ ...value, to: e.target.value })}
      />
      {PRESETS.map((p) => (
        <button key={p.key} className="rep-btn" onClick={() => onChange(presetRange(p.key))}>
          {p.label}
        </button>
      ))}
      <span className="rep-muted">{rangeLabel(value)}</span>
    </div>
  )
}
